
<template>
<div>
        <div
      class="d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"
    >
      <div>
        <router-link :to="{ path: '/directors'}">
          <button type="submit" class="btn btn-danger  btn-sm  px-2 mr-2">Yönetim Kurulu</button>
        </router-link>
        <router-link :to="{ path: '/staffs'}">
          <button type="submit" class="btn btn-info  btn-sm mr-2 px-2">Federasyon Personeli</button>
        </router-link>
        <router-link :to="{ path: '/all-leaders'}">
          <button type="submit" class="btn btn-primary btn-sm mr-2 px-2">Başkanlarımız</button>
        </router-link>
        <router-link :to="{ path: '/history'}">
          <button type="submit" class="btn btn-success btn-sm mr-2 px-2">Tarihçe</button>
        </router-link>
        <router-link :to="{ path: '/sub-board-categories'}">
          <button type="submit" class="btn btn-warning text-white active btn-sm mr-2 px-2">Alt Kurullar</button>
        </router-link>
        <router-link :to="{ path: '/provincial-offices'}">
          <button type="submit" class="btn btn-secondary  btn-sm  mr-2 px-2">İl Temsilcilikleri</button>
        </router-link>
        <router-link :to="{ path: '/bank-informations'}">
          <button type="submit" class="btn btn-success  btn-sm  mr-2 px-2">Hesap Numaraları</button>
        </router-link>
        <router-link :to="{ path: '/main-status-instructions'}">
          <button type="submit" class="btn btn-info btn-sm mr-2 px-2">Ana Statü Talimatlar</button>
        </router-link>
      </div>
      <span></span>
    </div>
        <div
      class="d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"
    >
      <div>
        <router-link :to="{ path: '/sub-board-categories'}">
          <button type="submit" class="btn btn-danger active btn-sm  px-5 mr-4">Alt Kurullar</button>
        </router-link>
        <router-link :to="{ path: '/sub-boards'}">
          <button type="submit" class="btn btn-warning  btn-sm mr-4 px-5">Kişiler</button>
        </router-link>

      </div>
      <span></span>
    </div>
  <card>
    <div v-if="!err">

    <h4 slot="header" class="card-title d-md-flex justify-content-between">
      <span>Alt Kurullar</span>
      <div>
        <router-link v-b-tooltip title="Yeni Kurul Ekle" :to="{ path: 'sub-board-categories/add-edit/'}" class="btn btn-primary" tag="li"><i class="fas fa-plus"></i> Yeni Kurul</router-link>
      </div>
    </h4>
    <div class="row">
      <div class="col-12">
        <h6 class="ml-3">Kategoriler</h6>
        <b-tabs pills card vertical>
            <div class="row" v-for="(category, index) in categories" :key="index">
              <div class="col-12 card mb-1">
                <div class="card-body p-2">
                  <h5 class="d-md-flex justify-content-between align-items-center m-0">
                    <span>{{category.name}}</span>
                    <div>
                      <router-link v-b-tooltip title="Düzenle" :to="{ path: 'sub-board-categories/add-edit/'+category.id+'/0'}" class="btn btn-primary btn-fill btn-xs" tag="li"><i class="fas fa-edit"></i></router-link>
                      <button v-on:click="remove(category.id,'categories')"  v-b-tooltip title="Sil" class="btn btn-danger btn-xs"><i class="fas fa-eye-slash"></i></button>
                      <a href="javascript:void(0)" class="btn btn-xs btn-danger btn-fill" v-if="category.is_active" v-on:click="deactivate(category.id,'categories')" v-b-tooltip title="Yayından Kaldır" id="remove-item.id"><i class="fas fa-eye-slash"></i></a>
                      <a href="javascript:void(0)" class="btn btn-xs btn-success btn-fill" v-if="!category.is_active" v-b-tooltip v-on:click="activate(category.id,'categories')" title="Yayına al" id="activate-item.id"><i class="fas fa-eye"></i></a>
                    </div>
                  </h5>
                </div>
              </div>
            </div>
        </b-tabs>
      </div>
    </div>

    </div>
<div v-if="err">
{{err}}
</div>
  </card>
  </div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'

  export default {
    data: function () {
      return {
        category:{
          is_active:0
        },
        err:null,
        categories: null,
        total: 0,
        limit: localStorage.getItem('filterLimit'),
        page: 1,
        pageCount: null,
        navigation: true,
        type: 'all',
        viewCounts: []
      }
    },
    components: {
      Card
    },

    methods: {
      deactivate: function(id,type){
        this.toggleLoader()
        this.category.is_active = 0
        this.$http.post('/api/' + type + '/edit/' + id, this.category).then(
          response => {
            this.notifier('top', 'right', 'warning', 'Kategori Yayından Kaldırıldı')
            this.getPosts()
            this.toggleLoader()
          },
          e => {
                        this.toggleLoader()

                                   if(!e.body.Error){
            this.notifier("top", "right", "danger", "Bir Hata Oluştu");
            }else{
            this.notifier("top", "right", "danger", e.body.Error);
            }
          })
      },
      remove: function(id,type){
        this.toggleLoader()
        this.$http.post('/api/' + type + '/delete/' + id, this.category).then(
          response => {
            this.notifier('top', 'right', 'warning', 'Kategori Silindi')
            this.getPosts()
            this.toggleLoader()
          },
          e => {
                        this.toggleLoader()

                                              if(!e.body.Error){
            this.notifier("top", "right", "danger", "Bir Hata Oluştu");
            }else{
            this.notifier("top", "right", "danger", e.body.Error);
            }
          })
      },
      activate: function(id,type){
        this.toggleLoader()
        this.category.is_active = 1
        this.$http.post('/api/' + type + '/edit/' + id, this.category).then(
          response => {
            this.notifier('top', 'right', 'success', 'Kategori Yayına Alındı')
            this.getPosts()
            this.toggleLoader()
          },
          e => {
                        this.toggleLoader()

                                   if(!e.body.Error){
            this.notifier("top", "right", "danger", "Bir Hata Oluştu");
            }else{
            this.notifier("top", "right", "danger", e.body.Error);
            }
          })
      },

      getPosts: function () {
        this.toggleLoader()
        var url = '/api/categories/all-with-joins-sub-boards/'
        this.$http
        .get(url)
        .then(
          response => {
            this.categories = response.body
            this.toggleLoader()
          },
          er => {
                    this.toggleLoader()

if(!er.body.Error){
             this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            }else{
              this.err = er.body.Error;
            this.notifier(
              'top',
              'right',
              'danger',
              er.body.Error
              )
            }
          }
          )
      },
      toggleNavigation () {
        var button = event.target
        if (this.navigation) {
          button.innerHTML = '<i class="fas fa-caret-down"></i>'
          this.navigation = false
        } else {
          button.innerHTML = '<i class="fas fa-caret-up"></i>'
          this.navigation = true
        }
      },
      toggleNewPostPanel (event) {
        event.stopPropagation()
        if (document.getElementById('new-post').classList.contains('d-none')) {
          document.getElementById('new-post').classList.remove('d-none')
        } else {
          document.getElementById('new-post').classList.add('d-none')
        }
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.getPosts()
      })
    }
  }
</script>
<style>
.nav .nav-item .nav-link:hover, .nav .nav-item .nav-link:focus{
  background-color: #007bff !important;
}
.nav-pills:focus{
  outline: none;
}
.nav-pills a{
  color:#000;
}

.nav .nav-item .nav-link:hover, .nav .nav-item .nav-link:focus{
  color:#fff;
}
.nav-item{
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/SubBoardCategoriesModules/Main.vue